import { render, staticRenderFns } from "./rootNode.vue?vue&type=template&id=67dc0fe9&scoped=true"
import script from "./rootNode.vue?vue&type=script&lang=js"
export * from "./rootNode.vue?vue&type=script&lang=js"
import style0 from "./rootNode.vue?vue&type=style&index=0&id=67dc0fe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc0fe9",
  null
  
)

export default component.exports